var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.866 3.878a3.931 3.931 0 000 5.529 3.861 3.861 0 005.497 0 3.931 3.931 0 000-5.529 3.885 3.885 0 00-5.475 0h-.022zm6.3 8.432a6.576 6.576 0 01-6.068.518 6.675 6.675 0 010-12.318 6.591 6.591 0 017.223 1.44 6.7 6.7 0 01.99 8.17l2.475 2.498a.75.75 0 010 1.05l-1.11 1.118a.75.75 0 01-1.05 0l-2.46-2.476z"
  })));
}
export default SvgSearch;